<div class="mw howItWorks {{showLang}}">
    <div class="row">
        <div class="xl-12">
            <h2>{{ 'static.howItWorks' | translate }}</h2>
        </div>
    </div>
    <div class="row">
        <div class="fl xs-12 sm-4 md-4 xl-4">
            <img src="../../../assets/images/newCircleIcons/hand.png"/>
            <h3>{{ 'static.ctl' | translate }}</h3>
            <p>{{ 'static.ctlBody' | translate }}</p>
        </div>
        <div class="fl xs-12 sm-4 md-4 xl-4">
            <img src="../../../assets/images/newCircleIcons/lotto.png"/>
            <h3>{{ 'static.play' | translate }}</h3>
            <p>{{ 'static.playBody' | translate }}</p>
        </div>
        <div class="fl xs-12 sm-4 md-4 xl-4">
            <img src="../../../assets/images/newCircleIcons/dollar.png"/>
            <h3>{{ 'static.win' | translate }}</h3>
            <p>{{ 'static.winBody' | translate }}</p>
        </div>
    </div>
</div>
